interface KeyObject {
  [key: string]: string;
}

const displayAttributeInner = (
  attribute: string,
  keyVal: KeyObject
): string => {
  const displayText = keyVal[attribute];

  if (!displayText) {
    throw new Error(`invalid attribute. attribute: ${attribute}`);
  }

  return displayText;
};

// 属性を表示できる形式にして返す
export const displayAttribute = (attribute: string): string => {
  return displayAttributeInner(attribute, {
    attributeEar: "EAR",
    attributeEyes: "EYES",
    attributeClothing: "CLOTHING",
    attributeDna: "DNA",
    attributeHairBack: "HAIR_BACK",
    attributeHairFront: "HAIR_FRONT",
    attributeFace: "FACE",
    attributeNeck: "NECK",
    attributeMouth: "MOUTH",
    attributeSkinTone: "SKIN TONE",
    attributeSpecial: "SPECIAL",
  });
};

export const displaySecondAttribute = (attribute: string): string => {
  return displayAttributeInner(attribute, {
    attributeSpecial: "SPECIAL",
    attributeHairFront: "HAIR_FRONT",
    attributeEar: "EAR",
    attributeNeck: "NECK",
    attributeCostume: "COSTUME",
    attributeFace: "FACE",
    attributeMouth: "MOUTH",
    attributeEye: "EYE",
    attributeSkin: "SKIN",
    attributeHairBack: "HAIR_BACK",
    attributeBackground: "BACKGROUND",
    geneType: "GENE_TYPE",
  });
};
